import { useEffect, useState } from 'react';
import { httpClient } from '@/utils/httpClient';

export interface ServerChoice {
  id: string;
  name: string;
}

/**
 * Loads the servers once, as select choices (licenses, account forms and filters, bulk reassign).
 * Fetched from `/admin/server/GetAllServers`.
 */
export const useServerChoices = () => {
  const [choices, setChoices] = useState<ServerChoice[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    httpClient
      .get<{ id: number | string; name: string }[]>('/admin/server/GetAllServers')
      .then(res => {
        if (active) setChoices((res.data || []).map(s => ({ id: String(s.id), name: s.name })));
      })
      .catch(() => {
        if (active) setChoices([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { choices, loading };
};
